import Vue from 'vue';
import { MutationTree } from "vuex";
import { TrialPeriodAdminzoneState } from "@/types/store/adminzone/trialPeriod";
import { TrialPeriodData } from "@/types";

export const mutations: MutationTree<TrialPeriodAdminzoneState> = {
  SET_TRIAL_PERIOD: (state, payload: Array<TrialPeriodData>): Array<TrialPeriodData> => Vue.set(state, 'trialPeriod', payload),
}
